import { message } from 'antd';

let isWaiting = false;
const getMessageTimeOut = (content) => {
  if (!content) return 3; // fallback if null, undefined, or empty string
  return Math.max(content.length * 0.05, 7);
};
export const debouncedErrorMessage = (content) => {
  if (isWaiting) return;

  const key = `msg_${Date.now()}_${Math.random()}`;
  const duration = getMessageTimeOut(content)
  // Show the message immediately
  message.error({
    content,
    duration,
    key,
    onClick: () => {
      message.destroy(key);
    }
  });

  const wait = duration * 500;

  isWaiting = true;
  setTimeout(() => {
    isWaiting = false;
  }, wait);
};